import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import useDeleteHook from "../../customHooks/useDeleteHook";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useSearchParams } from "react-router-dom";
const ProductComponent = loadable(() => import("../../components/Product"));

type Props = {};

const Product = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const { data: productData, isPending: productLoading } = useGetHook({
    queryKey: ["product", pageSize, offset, searchQuery],
    url: `${APIS.PRODUCT}`,
    params: {
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
    },
  });

  const { mutateAsync: deleteMutateAsync } = useDeleteHook({
    queryKey: ["product"],
  });

  const handleDelete = async (setOpenPopup: any, pk: string) => {
    const url = `${APIS.PRODUCT}${pk}/`;
    try {
      const res = await deleteMutateAsync({ url });
      setOpenPopup(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <ProductComponent
        productData={productData}
        handleDelete={handleDelete}
        pageSize={pageSize}
        setPageSize={setPageSize}
        offset={offset}
        setOffset={setOffset}
        productLoading={productLoading}
      />
    </div>
  );
};

export default Product;
